module.exports = __webpack_public_path__ + "img/06.bcaf3cb3.webp";